

























































const namespace = 'calendar';
import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { AppComponentsVisibility } from '@/plugins/vuetify/themes/types';
import BoxFooter from '@/modules/calendar/components/locations/BoxFooter.vue';
import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';
import { getBoxColor } from '@/utils/style';

@Component({
    name: 'MobileSingleActivityPopup',
    components: {
        BoxFooter,
    },
})
export default class MobileSingleActivityPopup extends Vue {
    @Prop() public eventProp!: ICalendarData;
    @Getter('componentsVisibility', { namespace: 'configuration' })
    private componentsVisibility!: AppComponentsVisibility;
    @Getter('locationWidth', { namespace }) protected locationWidth!: number;

    private get event(): ICalendarData {
        return this.eventProp;
    }

    private generateHref(id: number): string {
        return `#/form?e=${id}`;
    }

    private get startDate() {
        return this.event.StartDate
            ? this.event.StartDate.toLocaleString().slice(0, this.event.StartDate.indexOf('T'))
            : '';
    }

    private get style() {
        return `z-index: 200; position: fixed; margin-top: 170px;`;
    }

    private get visibility() {
        return this.componentsVisibility.calendar.locations.MobileSingleActivityPopups;
    }

    private get showShortId() {
        return this.visibility.ShortId ?? true;
    }

    private get showStartDate() {
        return this.visibility.StartDate ?? true;
    }

    private get showStartTime() {
        return this.visibility.StartTime ?? true;
    }

    private get showAddress() {
        return this.visibility.Address ?? true;
    }

    private get showAdvancedLevel() {
        return this.visibility.AdvanceLevel ?? true;
    }

    private get showStatus() {
        return this.visibility.ShortId ?? true;
    }

    private get showGroupDanceStyle() {
        return this.visibility.GroupDanceStyle ?? true;
    }

    private getBoxColor(event: ICalendarData) {
        return getBoxColor(event);
    }

    private closePopup() {
        this.$emit('closePopup');
    }

    protected getImage(url: string) {
        const pluginDirectory = process.env.VUE_APP_IMAGES_DIR;
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const imgUrl = require(`@/assets${url}`);
        return this.isWordPressPlugin && !imgUrl.startsWith('data:image/jpeg;base64')
            ? pluginDirectory + imgUrl
            : imgUrl;
    }

    protected get isWordPressPlugin() {
        return process.env.VUE_APP_IS_WORDPRESS_PLUGIN === 'true';
    }
}
